import {Routes} from '@angular/router'
import {adminAuthGuard, LoginComponent} from '@sparbanken-syd/sparbanken-syd-bankid'
import {HOME_PATH, LIST_PATH, LOGIN_PATH, SETTINGS_PATH} from './0-application/shared'
import {Settings} from './2-home/9-settings/settings'
import {Start as ListStart} from './2-home/2-list/start/start'
import {WriteHelp} from './2-home/5-write-help/write-help'
import {Test} from './2-home/10-test/test'
import {NewCase} from './1-components/0-owners/new-case/new-case'

export const routes: Routes = [
  {
    path: HOME_PATH,
    loadChildren: () => import('./2-home/routes'),
    canActivate: [adminAuthGuard]
  },
  {
    path: LOGIN_PATH,
    component: LoginComponent
  },
  {
    path: LIST_PATH,
    component: ListStart
  },
  {
    path: SETTINGS_PATH,
    component: Settings
  },
  {
    // Can and should be removed
    path: 'write',
    component: WriteHelp
  },
  // Possibly remove this when not needed.
  {
    path: 'test',
    component: Test
  },
  // Remove when done.
  {
    path: 'new',
    component: NewCase
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: LOGIN_PATH
  },
  {
    path: '**',
    redirectTo: LOGIN_PATH
  }
]
